(function() {
    $ = jQuery = fp.$ = window.jQuery.noConflict(true);
    _ = fp._ = window._.noConflict(true);

    dateFns = fp.dateFns;

    NProgress = fp.NProgress = window.NProgress;
    delete window.NProgress;

    if(typeof oldNProgress === 'object') {
        window.NProgress = oldNProgress;
        oldNProgress = undefined;
    }

    showdown = fp.showdown = window.showdown;
    delete window.showdown;

    if(typeof oldShowdown === 'object') {
        window.showdown = oldShowdown;
        oldShowdown = undefined;
    }

    S = fp.S = window.S;
    delete window.S;

    if(typeof oldS === 'object') {
        window.S = oldS;
        oldS = undefined;
    }

    numeral = fp.numeral = window.numeral;
    delete window.numeral;

    if(typeof oldNumeral === 'object') {
        window.numeral = oldNumeral;
        oldNumeral = undefined;
    }

    Lockr = fp.Lockr = window.Lockr;
    delete window.Lockr;

    if(typeof oldLockr === 'object') {
        window.Lockr = oldLockr;
        oldLockr = undefined;
    }

    //test if browser supports localStorage
    try {
        var item = 'fp';
        localStorage.setItem(item, item);
        localStorage.removeItem(item);
    }
    catch(exc) {
        Lockr = fp.Lockr = {
            set: $.noop,
            get: $.noop,
            rm: $.noop,
            flush: $.noop
        };
    }

    $.jMaskGlobals = {
        dataMask: false,
        watchDataMask: false
    };

    fp.jss = jss;

    //configure notifier (Bugsnag)
    bugsnag = window.bugsnag;
    delete window.bugsnag;

    if(typeof oldBugsnag === 'object') {
        window.bugsnag = oldBugsnag;
        oldBugsnag = undefined;
    }

    var isDev = fp.isDev(),
        enableBugsnag = !isDev;

    //removeIf(!debug)

    // isDev = false;
    // enableBugsnag = true;
    // enableBugsnag = false;

    //endRemoveIf(!debug)

    if(bugsnag && enableBugsnag && window.location.protocol.indexOf('http') == 0) {
        bugsnag.user = fp.notifier.user;
        bugsnag.metaData = fp.notifier.metaData;

        var fieldMask = 'XXXXXXXXX',
            maskFieldRegExps = _.map([
                'password',
                'card_number',
                'cardholder_name',
                'cvv'
            ], function(value) {
                return new RegExp('[\?&\.]' + value + '=([^&#]*)');
            });

        fp.notifier = bugsnag({
            apiKey: fp.bugsnagApiKey,
            appVersion: '1.0.0',
            releaseStage: fp.isProd() ? 'production' : isDev ? 'development' : 'staging',
            notifyReleaseStages: ['development', 'staging', 'production'],
            metaData: fp.notifier.metaData,
            user: fp.notifier.user,
            beforeSend: function (report) {
                var notifierUser = report.user,
                    errorMessage = S(report.errorMessage),
                    errorClass = (report.errorClass || '').toLowerCase(),
                    isWhitelisted = true;

                fp.ui.applyErrorMeta(report);

                notifierUser.id = fp.user.id;
                notifierUser.session = fp.session.token;
                notifierUser.selected_store_id = fp.getSelectedStoreId();
                notifierUser.order_id = fp.session.preference.order_id;

                //don't send ApiError that has no status field
                if(errorClass == 'apierror' && !report.metaData['meta data'].Status) {
                    isWhitelisted = false;
                }

                if(!isDev && isWhitelisted) {
                    // var debug = metaData.debug;
                    // debug.freshop = _.stringify(freshop, {exclude: ['events']});

                    if(
                        errorMessage.contains('Watchers fired in the last 5 iterations') ||
                        errorMessage.contains('A 429 error has occurred') ||
                        //ignore TypeError with elt.parentNode...this is happening in the Types Wordpress plugin
                        (errorClass == 'typeerror' && errorMessage.contains('elt.parentNode')) ||
                        //ignore Unhandled promise rejection
                        (errorClass == 'unhandledrejection' && errorMessage.eq('Unhandled promise rejection')) ||
                        //ignore accessibility script errors
                        errorMessage.contains('acsbJS is not defined') ||
                        //ignore unhandled resize observer
                        //https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
                        errorMessage.eq('ResizeObserver loop limit exceeded')
                    ) {
                        return false;
                    }

                    var apiUrl = metaData['API Url'];
                    if (apiUrl) {
                        _.each(maskFieldRegExps, function (item) {
                            apiUrl = apiUrl.replace(item, function (match, group) {
                                return match.substr(0, match.length - group.length) + fieldMask;
                            });
                        });
                        metaData['API Url'] = apiUrl;
                        metaData['API Base URL'] = apiUrl.split('?')[0];

                        //don't send products/ads AbortError to bugsnag
                        if (errorClass === 'aborterror') {
                            if(fp.config?.enableAbortErrorLog === false) return false;
                            const apiBaseUrl = S(metaData['API Base URL']);
                            const disableApi = _.find(fp.config?.disableAbortErrorLogApis, function(item) {
                                return (!item.appKey || item.appKey === fp.appKey) ? apiBaseUrl.endsWith(item.path) : false;
                            });
                            if(disableApi) return false;
                        }
                    }

                    if (!report.stacktrace) return true;

                    // Check if any non-whitelisted urls exist in stacktrace. If so we will not send this error
                    let matchUrls = new RegExp('https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}', 'gmi'),
                        hostname = S(window.location.hostname).toLowerCase(),
                        whitelistedDomains = 'freshop.com|cloudfront.net|stackpathdns.com|' + S(fp.assetCdnBaseUrl).trimRight('/').s + '|' + hostname.trimLeft('www.').replace(/([.])/g, '\\$1').s,
                        matchWhitelist = new RegExp(whitelistedDomains, 'i');

                    //reduce the number of category errors tracked (only track one per page load)
                    if(errorMessage.contains('CategoryError: More than one top level')) {
                        isWhitelisted = false;
                    }

                    if(isWhitelisted) {
                        if (hostname.contains('reasors.com') && errorMessage.contains('Unexpected token \'<\'')) {
                            isWhitelisted = false;
                        }
                        else {
                            //ignore specific error from Divi theme (Memphis Cash Saver) script
                            const hasUnrecognizedExp = errorMessage.contains('unrecognized expression: #!/');

                            //cannot replicate this error, only occurs for annonymous sessions Windows 10, Chrome v106.0.0
                            const hasUndefinedCallbacks = errorClass == 'typeerror' && errorMessage.contains('Cannot read properties of undefined (reading \'callbacks\')');

                            //cannot replicate this error, only occurs for Safari
                            const hasUndefinedContext = errorClass == 'typeerror' && errorMessage.contains('undefined is not an object (evaluating \'r["@context"].toLowerCase\')');
                            
                            let file,
                                method;
                            _.find(report.stacktrace, function (item) {
                                file = S(item.file);
                                method = S(item.method);
                                const isGlobalCode = !file.length || file.trimRight('/').eq(location.origin) || method.contains('global code') || method.contains('unknown');

                                if (hasUndefinedCallbacks && isGlobalCode) {
                                    isWhitelisted = false;
                                }
                                else if (hasUndefinedContext && isGlobalCode) {
                                    isWhitelisted = false;
                                }
                                else if (hasUnrecognizedExp && file.contains('memphiscashsaver.com')) {
                                    isWhitelisted = false;
                                }
                                //ignore all errors from WP GTM script
                                else if(file.contains('/wp-content/plugins/duracelltomi-google-tag-manager')) {
                                    isWhitelisted = false;
                                }
                                else {
                                    matchUrls.lastIndex = 0;
                                    _.find(file.match(matchUrls), function (value) {
                                        if (!value.match(matchWhitelist)) {
                                            isWhitelisted = false;
                                            return true;
                                        }
                                    });
                                }

                                return !isWhitelisted;
                            });
                        }
                    }
                }

                if(!fp.isProd() || fp.getPrefCookie().log_error) {
                    if (!errorMessage.startsWith(report.errorClass + ':')) {
                        errorMessage = S(fp.util.formatString(
                            '{0}: {1}',
                            report.errorClass,
                            errorMessage.s
                        ));
                    }
                    fp.logError(errorMessage.s);
                    fp.log('metaData:', metaData);
                }

                return isWhitelisted;
            }
        });
    }
})();